import clsx from "clsx";
import React from "react";
import "./analyticsStatsRoot.scss";

interface IAnalyticsStatsRootProps extends React.ComponentPropsWithoutRef<"div"> { }

export const AnalyticsStatsRoot = (props: IAnalyticsStatsRootProps) => {
    return <div {...props} className={clsx("analytics-stats-root", props.className)} />;
};
